import React from "react";
import Skills from "../components/Skills";
import styles from "../styles/pages/home.module.css"

function Home() {
    return (
        <div className={styles.wrapper}>
            <div className={styles.hi}>
                <p className={styles.hiTitle}>First of all...</p>
                <p className={styles.hiElement}>Hi, My name is Souhail Khan</p>
                <p className={styles.hiElement}>I'm a Developer</p>
                <p className={styles.hiElement}>I live in France</p>
                {/* dynamic birthday */}
                <p className={styles.hiElement}>I'm {Math.floor((Date.now() - new Date("2008-05-11").getTime()) / 31557600000)}yo and I'm a student</p>
            </div>
            <Skills className={styles.skills} />
        </div>
    );
}

export default Home;
